<template>
    <div class="section grey-card">
        <v-container class="px-10">
            <v-row cols="12" justify="center">
                <v-col xl="4" lg="5" md="6" cols="12" class="px-10">
                    <h2 class="section__header-title text-h3 font-weight-bold">Always-On Support</h2>
                    Whether it’s a student needing help or a professional member looking for advice, Web Chat gives your team a single screen to manage conversations across every channel.
                    <div>
                        <v-list class="features grey-card">
                            <v-list-item v-for="item in items" :key="item.text">
                                <v-list-item-icon>
                                    <v-icon color="primary">mdi-{{ item.icon }}</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-text>{{ item.text }}</v-list-item-text>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </div>

                </v-col>
                <v-col xl="4" lg="4" md="6" col="12">
                    <v-img
                    src="../assets/img/chat-translate.png"
                    contain
                    max-width="600px"
                    height="400px"
                    alt="Chat translation"
                     /> 
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
export default {
    name: 'WorkflowsFeatures',
    data: () => ({
        items: [
            {
                text: 'Route inquiries to the right team with smart rules',
                icon: 'map-marker-path'
            },
            {
                text: 'Translate messages in real time for diverse memberships',
                icon: 'translate'
            },
            {
                text: 'Use quick replies and chatbots to handle FAQs instantly',
                icon: 'message-flash'
            },
        ]
    })
}
</script>




<style lang="scss">

</style>